export const getNavigateLinkByIdAndUid = ({
  baseUrl = '/details/organizations',
  id,
  uid,
}) => {
  if (id) return `${baseUrl}/id/${id}`;

  return `${baseUrl}/uid/${uid}`;
};

export const getOrgLinkByIdAndUid = ({ id, uid }) =>
  getNavigateLinkByIdAndUid({
    uid,
    id,
    baseUrl: '/details/organizations',
  });

export const getPeopleLinkByIdAndUid = ({ id, uid }) =>
  getNavigateLinkByIdAndUid({
    uid,
    id,
    baseUrl: '/details/people',
  });
